import React from 'react';
import { Link } from 'react-router-dom';
import ToolTip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faClock, faImage, faMap, faMoneyBills, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const MainNav = () => {
    return(
        <div id="main-nav">
            <ToolTip placement="bottom" trigger={['hover']} overlay={<span>Accueil</span>}>
                <Link to="/" className="btn">
                    <FontAwesomeIcon icon={faHome} />
                </Link>
            </ToolTip>
            <ToolTip placement="bottom" trigger={['hover']} overlay={<span>Consulter les horaires</span>}>
                <Link to="/horaires" className="btn">
                    <FontAwesomeIcon icon={faClock} />
                </Link>
            </ToolTip>
            <ToolTip placement="bottom" trigger={['hover']} overlay={<span>Voir des photos</span>}>
                <Link to="/photos" className="btn">
                    <FontAwesomeIcon icon={faImage} />
                </Link>
            </ToolTip>
            <ToolTip placement="bottom" trigger={['hover']} overlay={<span>Voir le trajet sur une carte</span>}>
                <Link to="/carte" className="btn">
                    <FontAwesomeIcon icon={faMap} />
                </Link>
            </ToolTip>
            <ToolTip placement="bottom" trigger={['hover']} overlay={<span>Consulter les tarifs</span>}>
                <Link to="/tarifs" className="btn">
                    <FontAwesomeIcon icon={faMoneyBills} />
                </Link>
            </ToolTip>
            <ToolTip placement="bottom" trigger={['hover']} overlay={<span>Nous contacter</span>}>
                <Link to="/contact" className="btn">
                    <FontAwesomeIcon icon={faEnvelope} />
                </Link>
            </ToolTip>
        </div>
    );
};

export default MainNav;